"use client"

import { useEffect, useState } from "react"
import { useRouter, usePathname } from "next/navigation"
import { useAuth } from "@/contexts/auth-context"
import { clientStorage } from "@/lib/client-utils"

// Маршруты, доступные без авторизации (стенд биометрии — публичный экран)
const PUBLIC_PATHS = new Set(["/login", "/register", "/biometria"])

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, loading: isLoading } = useAuth()
  const router = useRouter()
  const pathname = usePathname()
  const [hasToken, setHasToken] = useState<boolean>(false)
  const [tokenCheckTimeout, setTokenCheckTimeout] = useState<boolean>(false)

  // Check for token on client side only
  useEffect(() => {
    const token = clientStorage.getItem('token')
    setHasToken(!!token)
    
    // Add timeout to prevent infinite spinner during logout
    const timeoutId = setTimeout(() => {
      setTokenCheckTimeout(true)
    }, 2000) // 2 seconds timeout
    
    return () => clearTimeout(timeoutId)
  }, [])

  // Handle navigation based on auth state
  useEffect(() => {
    if (!isLoading) {
      if (!user && !hasToken && !PUBLIC_PATHS.has(pathname)) {
        router.push("/login")
      } else if (user && (pathname === "/login" || pathname === "/register")) {
        // /biometрия не редиректим даже для авторизованных:
        // стенд-экран используется и под админом на том же браузере
        router.push("/timesheets")
      }
    }
  }, [user, hasToken, pathname, isLoading, router])

  // Показываем загрузку во время проверки авторизации
  // Added tokenCheckTimeout to break out of spinner after timeout period
  if ((isLoading || (!user && hasToken)) && !tokenCheckTimeout) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-dark"></div>
      </div>
    )
  }

  return <>{children}</>
}

